




import QuestHub from "../../assets/img/NewUI_Images/QuestHub.jpg"

import parch from '../../assets/img/games/parch.webp';

import FloatingHub from "../../assets/img/screens/FloatingHub.mp4";
import QuestHubVideo from "../../assets/img/screens/QuestHub.mp4";
import FutureThemeLab from 'assets/glb/FutureThemeLab.jpg';
import FutureThemeLab1 from 'assets/glb/FutureThemeLab1.jpg';
import FutureThemeWorkshop from 'assets/glb/FutureThemeWorkshop.jpg';
import FutureThemeWorkShop1 from 'assets/glb/FutureThemeWorkShop1.jpg';

import QueueBackground from '../../assets/img/games/Quest_background.webp';

 import FutureMale from 'assets/img/CharacterSelectfutImg/Futuristic1.webp';
import FutureFemale from 'assets/img/CharacterSelectfutImg/Futuristic2.webp';

import FutureThemeMale from 'assets/img/CharacterSelectFutureThemeImg/Maleplayer2.png';
import FutureThemeMale1 from 'assets/img/CharacterSelectFutureThemeImg/MalePlayer3.png';
import FutureThemeFemale from 'assets/img/CharacterSelectFutureThemeImg/FemalePlayer2.png';
import FutureThemeFemale1 from 'assets/img/CharacterSelectFutureThemeImg/FemalePlayer3.png';

import MaleMentor from 'assets/img/CharacterSelectFutureThemeImg/MaleMentor.png';
import FemaleMentor from 'assets/img/CharacterSelectFutureThemeImg/FemaleMentor.png'


export const assetImageSrc = [
  

 
  { assetType: 'parch', src: parch },
 
  { assetType: 'QueueBackground', src: QueueBackground },
 
  {assetType:'QuestHub',src:QuestHub},
  {assetType:'FloatingHub',src:FloatingHub},
  {assetType:'QuestHubVideo',src:QuestHubVideo},
  
  

 
  {
    assetType: 'Player_Image',
    src: [
     
      {theme:'Future',id:'male', name:'FuturisticMaleUser',src: FutureMale },
      {theme:'Future',id: 'female',name:'FuturisticFemaleUser', src: FutureFemale },
     

      {theme:'FutureTheme',id: 'male',name:'FutureThemeMale', src: FutureThemeMale },
       {theme:'FutureTheme',id: 'female',name:'FutureThemeFemale', src: FutureThemeFemale },
      {theme:'FutureTheme',id: 'male',name:'FutureThemeMale1', src: FutureThemeMale1 },
    
      {theme:'FutureTheme',id: 'female',name:'FutureThemeFemale1', src: FutureThemeFemale1 },
        {theme:'FutureTheme',id:'male', name:'FuturisticMaleUser',src: FutureMale },
      {theme:'FutureTheme',id: 'female',name:'FuturisticFemaleUser', src: FutureFemale },
      {theme:'FutureThemeMentor',id: 'male',name:'MaleMentor', src: MaleMentor },
      {theme:'FutureThemeMentor',id: 'female',name:'FemaleMentor', src: FemaleMentor },

    ]
  },


  {
    assetType: 'BackgroundScreenshots',
    src:[
     
       {name:'FutureTheme Lab',src:FutureThemeLab},
      {name:'FutureTheme Workshop',src:FutureThemeLab1},
      {name:'FutureTheme Lab 1',src:FutureThemeWorkshop},
      {name:'FutureTheme Workshop',src:FutureThemeWorkShop1},

    ]
  }
];
